module.exports = __webpack_public_path__ + "static/media/speaker3.5ad8faf7.jpg";